import React from 'react';
import Icon from '../../../../components/ui/AppIcon';
import "./Floating_Call_Support.css"

const Floating_Call_Support = () => {
  return (
    <div className=" call_support">
      <a
        href="tel:+919405709042"
        className="flex items-center justify-center space-x-2 bg-secondary text-secondary-foreground px-2 py-2 rounded-lg font-semibold hover:bg-secondary/90 transition-default"
      >
        <Icon name="PhoneIcon" size={20} variant="solid" />
        <span>Call Now</span>
      </a>
      <a
        href="https://wa.me/919730088168"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center space-x-2 bg-success text-success-foreground px-2 py-2 rounded-lg font-semibold hover:bg-success/90 transition-default"
      >
        <Icon name="ChatBubbleLeftRightIcon" size={20} variant="solid" />
        <span>WhatsApp</span>
      </a>
    </div>
  );
};

export default Floating_Call_Support;
